export default __webpack_public_path__ + "static/media/Figtree-ExtraBold.4f69ac3b.ttf";